import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { RestaurantProduct } from '../../../libs/proto/restaurant_pb';
import { Product } from '../../../libs/proto/shop_pb';

@Injectable({
  providedIn: 'root'
})
export class RestaurantProductConversionService {

  constructor() { }

  ToStorage(req: RestaurantProduct) {
    const w = new BinaryWriter();
    RestaurantProduct.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  ToFromStorage(data: any, callback: (news: RestaurantProduct, errorConvert: any) => void) {
    try {
      callback( RestaurantProduct.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(news: RestaurantProduct[]) {
    const rets = new Array<Uint8Array | number[]>();

    news.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (news: RestaurantProduct[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<RestaurantProduct>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = RestaurantProduct.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
